import graphql__e5e16ef2e8fc5a7d1e30 from "./__generated__/CalendarDayEventsPanel_events.graphql.js";import { graphql, useFragment } from "react-relay";
import { List, Drawer } from "rsuite";

import CalendarResourceItem from "./CalendarResourceItem";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";
import Modal from "../Modals/Modal";
import { useFormatDate } from "../Intl/Context";

const CalendarDayEventsPanel = ({ date, onClose, ...props }) => {
  const events = useFragment(CalendarDayEventsPanel_events, props.events);

  const { isDesktop } = useResponsiveFlag();
  const formatDate = useFormatDate();

  if (!events || events.length === 0) return null;

  const title = formatDate(date, { weekday: "long", day: "numeric", month: "long" });

  const list = (
    <List bordered className="calendar-events-list">
      {events.map(event => (
        <CalendarResourceItem key={event.id} event={event} />
      ))}
    </List>
  );

  if (isDesktop) {
    return (
      <Modal shouldCloseOnOverlayClick={true} title={title} onRequestClose={onClose}>
        <div className="box">{list}</div>
      </Modal>
    );
  } else {
    return (
      <Drawer onClose={onClose} placement="right" open={true} size="full">
        <Drawer.Header>
          <h3 className="text-subtitle-section font-weight-bold">{title}</h3>
        </Drawer.Header>

        <Drawer.Body>{list}</Drawer.Body>
      </Drawer>
    );
  }
};

const CalendarDayEventsPanel_events = graphql__e5e16ef2e8fc5a7d1e30;

export default CalendarDayEventsPanel;
